import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetCustomRequestFiles(params) {
  const res = await api.get(routes.GET_CUSTOM_REQUEST_FILES, {
    params: params,
  });
  return res;
}
